import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AlertComponent = (
  title,
  mess,
  props,
  btnFunc,
  showAsToast = true,
  btnTxt = "OK"
) => {
  const MySwal = withReactContent(Swal);
  const propsFixed = props ?? {};

  let toastProps = {};
  if (showAsToast) {
    toastProps = {
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: "success",
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    };
  }

  const args = {
    ...toastProps,
    ...propsFixed,
    target: document.body,
    title,
    text: mess,
  };

  if (btnTxt && !args.confirmButtonText) args.confirmButtonText = btnTxt;

  return MySwal.fire(args).then((result) => {
    if (btnFunc) btnFunc(result, result.value);
    return result;
  });
};

export default AlertComponent;
